import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Link } from 'react-router-dom';
export function DefenceProcurementPage() {
  return <>
      <PageHero label="Manufacturing" title="Defence Procurement" subtitle="Specialist support for complex defence contracts, tenders, and bespoke equipment development." data-id="element-691" />
      <Breadcrumbs items={[{
      label: 'Manufacturing',
      to: '/manufacturing'
    }, {
      label: 'Defence Procurement'
    }]} data-id="element-692" />

      <section className="bg-white py-24" data-id="element-693">
        <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-694">
          <div className="prose prose-lg text-steel-600" data-id="element-695">
            <p className="lead" data-id="element-696">
              We understand the unique challenges of defence procurement. From
              rigorous compliance standards to rapid deployment requirements,
              our processes are aligned with MoD and international defence
              expectations.
            </p>
            <p data-id="element-697">
              Our team includes former military personnel who understand the
              operational context of every item we manufacture. We work closely
              with procurement teams to ensure technical specifications are met
              or exceeded, while maintaining cost-efficiency and supply chain
              security.
            </p>
          </div>
          <div className="mt-12" data-id="element-698">
            <Link to="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-cg-orange-600 text-white font-bold uppercase tracking-wider rounded-sm hover:bg-cg-orange-500 transition-colors" data-id="element-699">
              Contact Defence Team
            </Link>
          </div>
        </div>
      </section>
    </>;
}